import { IPublishTerms } from '../types';
import { mergeId } from './mergeId';

interface IMergePublishTermsParams {
  prevTerms: IPublishTerms;
  nextTerms: IPublishTerms;
}

/**
 *
 * @description Мержит услуги размещения, сохраняя при этом предыдущее состояние
 */
export function mergePublishTerms(params: IMergePublishTermsParams): IPublishTerms {
  const { prevTerms, nextTerms } = params;

  const selectedServiceId = mergeId(prevTerms.selectedServiceId, nextTerms.selectedServiceId, nextTerms.serviceIds);
  const periodsInfo = !!selectedServiceId && nextTerms.periodsByService[selectedServiceId];

  const selectedPeriodId = periodsInfo
    ? mergeId(prevTerms.selectedPeriodId, nextTerms.selectedPeriodId, periodsInfo.periodIds)
    : null;

  return {
    ...nextTerms,
    selectedServiceId,
    selectedPeriodId,
  };
}
